import { fetchHoj } from './client';
import type { Destination } from './types';

interface DestinationList {
  data: Destination[];
  meta?: { nextCursor?: string | null };
}

const CACHE_KEY = 'wp:destinationsCache';

export async function listDestinations(signal?: AbortSignal): Promise<Destination[]> {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      return JSON.parse(cached) as Destination[];
    }
  } catch {
    // ignore
  }

  const out: Destination[] = [];
  let cursor: string | undefined;
  do {
    const page = await fetchHoj<DestinationList>('/v1/destinations', {
      query: { limit: 100, cursor },
      signal,
    });
    out.push(...page.data);
    cursor = page.meta?.nextCursor ?? undefined;
  } while (cursor);

  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(out));
  } catch {
    // ignore
  }
  return out;
}

export function buildDestinationMap(list: Destination[]): Map<string, Destination> {
  const map = new Map<string, Destination>();
  for (const d of list) map.set(d.id, d);
  return map;
}
